<template>
<div class="s12 m12 l12">
     <!--<div v-if="user.chat" class="fixed-action-btn" style="bottom: 45px; right: 24px;">
        <a class="btn-floating btn-large purple darken-4">
          <i class="material-icons" @click="openChatSala()">voice_chat</i>
        </a>
    </div>-->
    
    <div v-if="user" class="fixed-action-btn horizontal">
      <div v-if="connectedFlag === true">
        <a class="btn-floating btn-large ">
          <i class="material-icons">menu</i>
        </a>
      </div>
      <div v-else>
        <a data-tooltip="Error de conexión" class="btn-floating btn-large red darken-4">
          <i class="material-icons">error_outline</i>
        </a>
      </div>
      <ul style="">
        <li v-if="this.$route.params.u1 !== 'only' && isVideoSaving() && (user.role === 'Admin' || user.role === 'Teacher')"><a class="btn-floating blue darken-4" @click="openVideoSave()"><md-icon>stop_screen_share</md-icon></a></li>
        <li v-if="this.$route.params.u1 !== 'only' && !isVideoSaving() && (user.role === 'Admin' || user.role === 'Teacher')"><a class="btn-floating blue darken-4" @click="openVideoSave()"><md-icon>screen_share</md-icon></a></li>
        <li v-if="this.$route.params.u1 !== 'only' && user.chataudio"><a class="btn-floating purple darken-4" @click="openChatSala(false)"><md-icon>mic</md-icon></a></li>
        <li v-if="this.$route.params.u1 !== 'only' && user.chat"><a class="btn-floating purple darken-4" @click="openChatSala()"><md-icon >videocam</md-icon></a></li>
        <li><a class="btn-floating orange darken-4" @click="changeStyle('board')"><md-icon>grid_on</md-icon></a></li>
        <li><a class="btn-floating green darken-4" @click="changeStyle('pieces')"><md-icon>grain</md-icon></a></li>
        <!-- <li v-if="this.styles!=undefined"><a class="btn-floating orange darken-4" @click="changeStyle('board')"><md-icon>grid_on</md-icon></a></li>
        <li v-if="this.styles!=undefined"><a class="btn-floating green darken-4" @click="changeStyle('pieces')"><md-icon>grain</md-icon></a></li>-->
      </ul>
    </div>
    <div>
      <!-- <md-dropdown-list>
          <md-dropdown-item v-link="{name: 'game', activeClass: 'active', params: {idBoard: 'board1'}}" :key="boardname" v-if="user"><md-icon right>looks_one</md-icon>{{ $t("game.title") }}</md-dropdown-item>
          <md-dropdown-item v-link="{name: 'game', activeClass: 'active', params: {idBoard: 'board2'}}" :key="boardname" v-if="user"><md-icon right>looks_two</md-icon>{{ $t("game.title") }}</md-dropdown-item>
          <md-dropdown-item v-link="{name: 'game', activeClass: 'active', params: {idBoard: 'board3'}}" :key="boardname" v-if="user"><md-icon right>looks_3</md-icon>{{ $t("game.title") }}</md-dropdown-item>
          <md-dropdown-item v-link="{name: 'game', activeClass: 'active', params: {idBoard: 'board4'}}" :key="boardname" v-if="user"><md-icon right>looks_4</md-icon>{{ $t("game.title") }}</md-dropdown-item>
          <md-dropdown-item v-link="{name: 'game', activeClass: 'active', params: {idBoard: 'board5'}}" :key="boardname" v-if="user"><md-icon right>looks_5</md-icon>{{ $t("game.title") }}</md-dropdown-item>
      </md-dropdown-list>-->
      <md-navbar v-if="this.$route.params.u1 !== 'only'" href="openModal" data-tooltip="" hamburger mode="hide-on-med-and-down" nav-class="purple darken-4">
        <div class="left left-nav">
          <md-nav-item class="tooltip-bottom" data-tooltip="Jugar" v-link="{name: 'home', activeClass: 'active'}" v-if="user">
            <span class="notoolbarnav"><md-icon class="notoolbarnav" left>play_circle_outline</md-icon></span>
            <!-- <md-icon left><img left class="responsive-img" width="25px" src="./assets/logo.svg" alt=""></md-icon>-->
            <md-icon left>
              <img left class="responsive-img noinsidenav" width="25px" :src="imageUrl(userClub.image)" alt="" @error="imageUrlAlt"></md-icon>
             <span class="inithome noinsidenav">{{ user.club }}</span>
            <span class="notoolbarnav">{{$t("game.play")}} <!--{{ $t("0.title") }} ({{ user.club.toUpperCase()}}--> </span>
          </md-nav-item>
          
          <md-nav-item @click="pcGameAnalisis()" v-if="user && (user.role === 'Admin' || user.role === 'Teacher')">
              {{$t("game.class")}}
              <md-icon left>cast</md-icon>
          </md-nav-item>
          <md-nav-item @click="pcGameAnalisis()" v-else>
              <span v-if="user">
                Analizar
                <md-icon left>cast</md-icon>
            </span>
          </md-nav-item>
          <md-nav-item v-link="{name: 'torneo',activeClass: 'active'}" v-if="user && user.firstName !== 'Guest'">
            {{ $t("torneos.title") }}
              <md-icon left>grid_on</md-icon>
          </md-nav-item>
          <md-nav-item v-link="{name: 'club',activeClass: 'active'}" v-if="user && (user.role === 'Admin')">
            {{ $t("clubs.title") }}
              <md-icon left>people_outline</md-icon>
          </md-nav-item>
          <!-- <md-nav-item v-link="{name: 'tournament', activeClass: 'active'}" v-if="user && (user.role === 'Admin' || user.role === 'Teacher')">
            {{$t("tournament.title")}}
            <md-icon left>grid_on</md-icon>
          </md-nav-item>-->
          <!--
          <md-nav-item v-link="{name: 'multiplayer',activeClass: 'active'}">Multijugador</md-nav-item>
          <md-nav-item v-link="{name: 'createServer',activeClass: 'active'}">Crear servidor</md-nav-item>
          -->
                   
          <!-- <md-nav-item href="javascript:void(0)" @click="openMenu($event)" v-if="user">
            <md-icon left>airplay</md-icon>
            Partidas
            <md-icon right>arrow_drop_down</md-icon>
          </md-nav-item>-->
          <!-- <md-nav-item @click="showInvitesGame()" v-if="user/* && $route.name!='game'*/">
              <md-icon left>play_circle_outline</md-icon>{{ $t("invites.title") }}
          </md-nav-item>-->
          <md-nav-item v-link="{name: 'visor', activeClass: 'active', params: board.boardParms}" v-if="user && user.firstName !== 'Guest'">
              {{$t("visor.title")}}
              <md-icon left>folder_open</md-icon>
          </md-nav-item>
          <md-nav-item v-link="{name: 'lesson', activeClass: 'active', params: board.boardParms}" v-if="user">
              {{$t("lesson.title")}}
              <md-icon left>library_books</md-icon>
          </md-nav-item>
          <md-nav-item v-link="{name: 'user',activeClass: 'active', params: {username: user.username}}"
                        v-if="user && user.firstName !== 'Guest'">
              <!--{{$t("user.title")}}: {{user.username}} ({{user.elo }})!-- ({{ user.role }})--> 
              <!-- {{$t("user.config")}}-->
              {{user.username}} <span class="badge green darken-4" style="color:white;">{{user.elo }}</span>
              <md-icon left>person_outline</md-icon>
              <!-- <img v-bind:src="user.image">-->
          </md-nav-item>
          <md-nav-item v-link="{name: 'puzzle',activeClass: 'active'}" v-if="user">
            {{ $t("puzzles.title") }}
              <md-icon left>create</md-icon>
          </md-nav-item>
          <md-nav-item v-link="{name: 'practice',activeClass: 'active'}" v-if="user">
            {{ $t("practice.title") }}
            <span class="tooltip-left tiny material-symbols-outlined left">chess_pawn</span>
            <!-- <md-icon left>computer</md-icon>-->
          </md-nav-item>
          <md-nav-item v-link="{name: 'loguin',activeClass: 'active'}" v-if="!user">
              {{ $t("user.login") }}
              <md-icon left>person_outline</md-icon>
          </md-nav-item>
          
          
          <md-nav-item v-if="!user" @click="changeLenguaje(lenguajes[lenIndex].value)"><md-icon left>flag</md-icon>{{ lenguajes[lenIndex].label }}</md-nav-item>
          
          <md-nav-item class="tooltip-bottom" data-tooltip="Salir" @click="logout()" v-if="user"><md-icon left class="red darken-4">exit_to_app</md-icon>
          <span class="">{{ $t("user.logout") }}</span>
          </md-nav-item>
  
        </div>
        <div class="right right-nav">
          <!-- <md-nav-item class="noinsidenav" v-if="user" @click="openModal()"><md-icon right>help_outline</md-icon></md-nav-item>-->
          <md-nav-item data-tooltip="Menú" class="noinsidenav tooltip-bottom" v-if="user">
            <a v-if="user" class='noinsidenav dropdown-button' data-activates='dropdown1'>
              <md-icon left>ondemand_video</md-icon>Vídeos<md-icon right>arrow_drop_down</md-icon>
            </a>
            <ul id='dropdown1' class='dropdown-content'>
              <!-- <li @click="openModalResources()"><a><md-icon left>queue_music</md-icon>Canal de radio</a></li>-->
              <li v-if="userClub.menu1_title" @click="openModalMenu1()"><a style="display: flex;"><md-icon left>school</md-icon><span style="white-space: nowrap">{{ userClub.menu1_title }}</span></a></li>
              <li v-if="userClub.menu2_title" @click="openModalMenu2()"><a style="display: flex;"><md-icon left>school</md-icon><span style="white-space: nowrap">{{ userClub.menu2_title }}</span></a></li>
              <li v-if="userClub.menu3_title" @click="openModalMenu3()"><a style="display: flex;"><md-icon left>school</md-icon><span style="white-space: nowrap">{{ userClub.menu3_title }}</span></a></li>
              
              <li class="divider" tabindex="-1"></li>
              <li @click="openModal()"><a style="display: flex"><md-icon left>help_outline</md-icon>Acerca de</a></li>
            </ul>
          </md-nav-item>
          <md-nav-item class="notoolbarnav" v-if="user" @click="openModal()">
            <md-icon left>help_outline</md-icon>
            <span style="white-space: nowrap">Acerca de</span>
          </md-nav-item>
          <md-nav-item v-if="user && userClub.menu1_title" @click="openModalMenu1()"
            class="tooltip-bottom notoolbarnav" data-tooltip="{{ userClub.menu1_title }}">
            <md-icon left>school</md-icon>
            <span style="white-space: wrap">{{ userClub.menu1_title }}</span>
          </md-nav-item>
          <md-nav-item v-if="user && userClub.menu2_title" @click="openModalMenu2()" 
            class="tooltip-bottom notoolbarnav" data-tooltip="{{ userClub.menu1_title }}">
            <md-icon left>school</md-icon>
            <span style="white-space: nowrap">{{ userClub.menu1_title }}</span>
          </md-nav-item>
          <md-nav-item v-if="user && userClub.menu3_title" @click="openModalMenu3()" 
            class="tooltip-bottom notoolbarnav" data-tooltip="{{ userClub.menu1_title }}">
            <md-icon left>school</md-icon>
            <span style="white-space: nowrap">{{ userClub.menu1_title }}</span>
          </md-nav-item>
          <md-nav-item  class="tooltip-bottom" data-tooltip="Retransmisión" v-link="{name: 'events',activeClass: 'active'}" v-if="user && user.live === true">
            <span>{{$t("events.title")}}</span>
            <md-icon left>live_tv</md-icon>
          </md-nav-item>
          <md-nav-item class="tooltip-bottom left" data-tooltip="Retos" style="padding-left: 0px" v-if="user" @click="showInvitesGame()">
            <md-icon left>bookmark_border</md-icon>
            <span class="">Retos</span>
            <span v-if="invitesLength > 0" class="badge green darken-4" style="color:white;"> {{invitesLength}}</span>
          </md-nav-item>
        </div>
      </md-navbar>
      <!-- <div iv id="modalVideo" class="frameVideoRight">
            <md-button class="right waves-effect waves-light purple darken-4" @click="this.getElementById('modalVideo').style.display='none'">
            X
          </md-button>
        <div style="text-align: center;height:100%;">
          <iframe width="400" height="100%" :src="srciFrameChatVideo" data-tooltip="" frameborder="0" allow="camera; microphone;" allowfullscreen></iframe>
        </div>
      </div>-->
      <md-modal id="aboutModalMenu1" class="modal-fixed-footer">
        <ul class="collection with-header">
        <li class="collection-header"><h4>{{ userClub.menu1_title }}</h4>
            <div v-html="userClub.menu1_text"></div>
        </li>
        <div style="text-align: center">
          <h5><a :href="userClub.menu1_link" target="_blank"><u>{{ userClub.menu1_title }}</u></a></h5>
          <iframe width="560" height="315" :src="userClub.menu1_video" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" data-tooltip="YouTube video player" frameborder="0" allow="" allowfullscreen></iframe>
        </div>
      </ul>
      <span slot="footer">
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'aboutModalMenu1')">
            {{ $t("about.close") }} <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
        </span>
      </md-modal>
      <md-modal id="aboutModalMenu2" class="modal-fixed-footer">
        <ul class="collection with-header">
        <li class="collection-header"><h4>{{ userClub.menu2_title }}</h4>
            <div v-html="userClub.menu2_text"></div>
        </li>
        <div style="text-align: center">
          <h5><a :href="userClub.menu2_link" target="_blank"><u>{{ userClub.menu2_title }}</u></a></h5>
          <iframe width="560" height="315" :src="userClub.menu2_video" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" data-tooltip="YouTube video player" frameborder="0" allow="" allowfullscreen></iframe>
        </div>
      </ul>
      <span slot="footer">
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'aboutModalMenu2')">
            {{ $t("about.close") }} <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
        </span>
      </md-modal>
      <md-modal id="aboutModalMenu3" class="modal-fixed-footer">
        <ul class="collection with-header">
        <li class="collection-header"><h4>{{ userClub.menu3_title }}</h4>
            <div v-html="userClub.menu3_text"></div>
        </li>
        <div style="text-align: center">
          <h5><a :href="userClub.menu3_link" target="_blank"><u>{{ userClub.menu3_title }}</u></a></h5>
          <iframe width="560" height="315" :src="userClub.menu3_video" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" data-tooltip="YouTube video player" frameborder="0" allow="" allowfullscreen></iframe>
        </div>
      </ul>
      <span slot="footer">
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'aboutModalMenu3')">
            {{ $t("about.close") }} <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
        </span>
      </md-modal>

      <md-modal id="aboutModalResources" class="modal-fixed-footer">
        <ul class="collection with-header">
        <li class="collection-header"><h4>Canal de radio<md-icon right>queue_music</md-icon></h4>
        <p>
            Se inaugura una sección de ajedrez dentro del programa de radio divulgativo Eureka perteneciente a Radio USAL. Esta sección se emitirá una vez al mes y en ella abordaremos noticias de interés tanto del panorama internacional, nacional y muy especialmente local, tratando así de fomentar la afición por nuestro deporte dentro de la población de Salamanca, así como dentro de la comunidad universitaria. Agradecemos a la dirección de Eureka esta oportunidad que nos brinda
        </p>
        </li>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa junio 2021. Historia del Ajedrez. Spassky vs Fischer 1972 </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa mayo 2021. Historia del Ajedrez. La Escuela Soviética </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa de radio abril 2021. Historia del ajedrez -Capablanca y Alekhine- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa noviembre 2020. Historia del ajedrez -Steinitz y Lasker- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa octubre 2020. Historia del Ajedrez. Siglo XIX </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa julio 2020. Historia del Ajedrez. Siglos XVI y XVII </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa junio 2020. Historia del Ajedrez. Siglo XVI -Ruy López- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa mayo 2020. Historia del Ajedrez. Capítulo III -El Renacimiento. En Salamanca se publican las nuevas reglas del ajedrez- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa abril 2020. Historia del Ajedrez. Capítulo II -Época árabe y Europa medieval- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa marzo 2020 </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa febrero 2020. Historia del Ajedrez. Capítulo I -Orígenes del juego- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa diciembre 2019 </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa noviembre 2019 </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa Mayo 2019 -El ajedrez en el desarrollo de la inteligencia artificial- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa Abril 2019 -Ajedrez y Música- </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa Marzo 2019 </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa Febrero 2019 </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Programa Enero 2019 </a>
        <a href="http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3" target="_blank" class="collection-item">Entrevista Noviembre 2018 </a>
      </ul>
      <span slot="footer">
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'aboutModalResources')">
            {{ $t("about.close") }}  <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
        </span>
      </md-modal>
      <md-modal id="aboutModal" class="modal-fixed-footer">
        <h4>{{ $t("about.description") }}</h4>
        <md-card>
            <span slot="title" class="activator">
               {{ $t("about.namegame") }}<md-icon right>info</md-icon>
            </span>
            <p>
               {{ $t("about.des") }}
            </p>
            <div slot="image" class="">
                <p></p>
                <img style=" width: 30%;left: 33%;" class="imagedropshadow activator" src="./assets/initboard.jpg" alt="">
            </div>
            <div slot="reveal">
              <span class="card-title grey-text text-darken-4">
                {{ $t("about.namegame") }}
              </span>
                <h5 class="flat-text-header hello">{{ $t("about.tecn") }}</h5>
                <p>
                    Vuejs, Nodejs, SocketIO, MongoDb, Materialize, Express, Cheessground, PgnViewerJS, SimpleChessBoard, Stockfish, LcZero, adminMongo, Webpack, ...
                </p>
                <h5 class="flat-text-header hello">{{ $t("about.licenses") }}</h5>
                <p>
                  <a target="_blank" rel="noopener noreferrer" href="../../../static/licenses.html">{{ $t("about.seemore") }}</a>
                </p>
            </div>
        </md-card>
        <span slot="footer">
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'aboutModal')">
            {{ $t("about.close") }} <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
        </span>
      </md-modal>
    <div>
      <user-invites :user="user"></user-invites>
    </div>
    <div class="row">
      <router-view></router-view>
    </div>
  </div>
</div>
</template>

<script>
import store from './vuex/store'
import UserService from './services/user'
import Board from './services/board'
import UserInvites from './components/home/invites'
import Lenguajes from './services/lenguajes'
import ClubService from './services/club'
import Store from './services/lstorage'
import config from '../server/config.js'
import toast from 'vue-material-components'
// import tooltip from 'vue-material-components'

var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}

export default {
  data () {
    return {
      srciFrameChatVideo: '',
      closeResult: '',
      userClub: {},
      user: UserService.getUser(),
      board: Board,
      lenguaje: Store.get('lenguaje', 'es'),
      lenguajes: Lenguajes.lenguajes,
      lenIndex: Store.get('lenIndex', '1'),
      lenguajeName: Lenguajes.lenguajes[0].label,
      invitesLength: 0,
      recording: false,
      lastSocketDisconnect: '',
      intervalId: null,
      connectedFlag: true,
      styleboard: true,
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        })
    }
  },
  mixins: [
    // tooltip
    toast
  ],
  methods: {
    loadClub (club) {
      // window.alert('loadClub ' + club)
      var parms = {
        name: club
      }
      var _self = this
      ClubService.get(_self, parms).then(function (response) {
        const theD = JSON.parse(response)
        _self.userClub = theD
        // window.alert(JSON.stringify(_self.userClub))
        // setTimeout(function () {
        if (_self.userClub !== undefined && _self.userClub.length > 0 && _self.userClub[0]) {
          _self.userClub = _self.userClub[0]
        }
        // }, 50)
      }, function (response) {
        this.error = response.data
      })
    },
    changeStyle (type) {
      this.styles[type] = this.styles[type] + 1
      if (this.styles[type] > stylesBoard[type].length - 1) {
        this.styles[type] = 0
      }
      // this.styleAdapter()
      Store.set('styleBoard', this.styles)
      this.$broadcast('updateBoards', this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']])
    },
    getLenguajeName () {
      for (var i in this.lenguajes) {
        if (this.lenguajes[i].value !== this.lenguaje) {
          this.lenguajeName = this.lenguajes[i].label
          break
        }
      }
    },
    pcGameAnalisis () {
      this.$broadcast('modal::open', 'invitePCAnalisis')
    },
    changeLenguaje (len) {
      if (this.lenguaje !== len) {
        Store.set('lenguaje', len)
        if (len === 'es') {
          this.lenIndex = 1
        } else {
          this.lenIndex = 0
        }
        Store.set('lenIndex', this.lenIndex)
        window.location.reload()
      }
    },
    existBoard (board) {
      if (Store.get(board)._id) {
        return true
      } else {
        return false
      }
    },
    openMenu (event) {
      this.$broadcast('dropdown-list::open', event, '')
    },
    openModal () {
      this.$broadcast('modal::open', 'aboutModal')
    },
    openModalResources () {
      this.$broadcast('modal::open', 'aboutModalResources')
    },
    openModalMenu1 () {
      this.$broadcast('modal::open', 'aboutModalMenu1')
    },
    openModalMenu2 () {
      this.$broadcast('modal::open', 'aboutModalMenu2')
    },
    openModalMenu3 () {
      this.$broadcast('modal::open', 'aboutModalMenu3')
    },
    showInvitesGame () {
      this.$broadcast('modal::open', 'invitesGame')
    },
    imageUrl (name) {
      var ret = ''
      if (name !== undefined) {
        ret = Store.get('serverDir') + '/uploads/' + name
      }
      return ret
    },
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultClub.png'
    },
    logout () {
      /* if (window.confirm('¿Desea salir de la aplicación? Se van a cerrar todas sus partidas')) {
        for (var i = 0; i <= 200; i++) {
          var boardToStore = 'board' + i
          if (Store.get(boardToStore) && Store.get(boardToStore)._id !== undefined &&
            (Store.get(boardToStore).u1 === this.user.username || Store.get(boardToStore).u2 === this.user.username)) {
            // window.alert('closing: ' + Store.get(boardToStore)._id + this.user.username)
            const result = {
              color: Store.get(boardToStore).u1 === this.user.username ? 'black' : 'white',
              motiv: 'closed'
            }
            var data = {
              c: 'board',
              f: 'gameFinish',
              data: {
                idBoard: Store.get(boardToStore)._id,
                result: result
              }
            }
            this.$socket.emit('event', data, function (...callbacks) {
              console.log(callbacks)
            })
          }
        }
        UserService.logout()
      }*/
      this.$route.router.replace('/home')
      UserService.logout(this)
      this.$route.router.replace('/')
    },
    testUser (next) {
      // window.alert(Store.get('token'))
      if (this.user) {
        var clubLast = this.user.club
        if (Store.get('token')) {
          // window.alert('testuser' + this.user.club + ' ' + this.user.club1 + ' ' + this.user.club2)
          // this.toast('<span>Comprobando token de usuario</span>', 1000, 'rounded')
          // this.toast(Store.get('token'), 1000, 'rounded')
          UserService.testUser(this, {}).then(function (response) {
            const data = JSON.parse(response)
            // data.club1 = data.club
            // window.alert('testuser ' + clubLast + ' - ' + data.club + ' ' + data.club1 + ' ' + data.club2)
            var club1 = data.club1
            var club2 = data.club2
            var club = data.club
            // Actualizar los valores de los clubes
            if (clubLast === club1) {
              data.club = club1 // El nuevo club pasa a ser el principal
              data.club1 = club // El antiguo club principal pasa a club1
            } else if (clubLast === club2) {
              data.club = club2 // El nuevo club pasa a ser el principal
              data.club2 = club // El antiguo club principal pasa a club2
            } else {
            }
            data.club = clubLast

            // window.alert('testuser ' + data.club + ' ' + data.club1 + ' ' + data.club2)
            UserService.setUser(data)
            next()
          }, function (response) {
            // next()
            this.error = response.data
          })
        }
      }
    },
    userLoguinSocket () {
      // this.toast('<span>Login</span>', 1000, 'rounded')
      let access = this.$route.params.u1 === 'only' ? 'guest' : 'authenticate'
      let user = UserService.getUser()
      if (UserService.user_acces(access)) {
        const data = {
          c: 'chat',
          f: 'username',
          data: {
            user: user
          }
        }
        setTimeout(function () {
          if (this.$socket) {
            if (!this.$socket || !this.$socket.connected) {
              window.swal('Socket desconectado')
            }
            this.$socket.emit('event', data, function (...callbacks) {
              console.log('USERLOGUINSOCKET: ' + callbacks[1])
            })
          }
        }.bind(this), 100)
      }
    },
    openChat (video = true) {
      if (config.debug) {
        let handler = window.open(config.video_uri_debug + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      } else {
        let handler = window.open(config.video_uri + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      }
    },
    isVideoSaving () {
      return this.recording === true // window.RECORDING_ONGOING
    },
    openVideoSave () {
      window.RECORDING_ONGOING = !window.RECORDING_ONGOING // Start / Stop recording
      if (window.RECORDING_ONGOING) {
        // recordingToggle.innerHTML = "Parar la grabación";
        var _self = this
        window.swal('No toque el título de arriba que indica dejar de compartir, simplemente cuando quiera parar la grabación pulse el botón de abajo.\nEl mismo que ha pulsado para comenzar\n¿Quiere continuar con la grabación?', {
          buttons: {
            si: {text: 'Sí', value: 's'},
            no: {text: 'No', value: 'n'}
          }
        }).then(function (resultParam) {
          window.startRecording() // Start the recording
          _self.recording = true
        })
      } else {
        // recordingToggle.innerHTML = "Empezar la grabación";
        window.stopRecording() // Stop screen recording
        this.recording = false
      }
    },
    openChatSala (video = true) {
      if (config.debug) {
        let handler = window.open(config.video_uri_debug + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      } else {
        let handler = window.open(config.video_uri + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      }
      // this.srciFrameChatVideo = 'https://' + document.location.hostname + ':8080?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video
      // this.$broadcast('modal::open', 'modalVideo')
    },
    loadOtherUser (otherUser, next) {
      if (otherUser !== 'PC' && otherUser !== undefined && otherUser.length > 0) {
        UserService.get(this, otherUser).then(function (response) {
          const dd = JSON.parse(response)
          const somedata = dd
          // window.alert(somedata.club)
          next(somedata)
        }, function (response) {
        // window.alert('mal: ' + otherUser)
        })
      } else {
        next({
          image: 'Droid-Robot-512.png'
        })
      }
    },
    checkServerStatus () {
      try {
        if (this.user) {
          if (this.$route.params.u1 !== 'only') {
            UserService.testUser(this, {}).then(function (response) {
              this.connectedFlag = true
            }, function (response) {
              this.connectedFlag = false
            })
          }
        }
      } catch (error) {
        this.connectedFlag = false
        // window.swal('Se ha perdido la conexión con el servidor')
      }
    },
    esperarSocket (fnObtenerSocket, maxRetries = 10, intervalo = 300) {
      return new Promise((resolve, reject) => {
        let intentos = 0
        const chequear = setInterval(() => {
          const socket = fnObtenerSocket
          if (this.$socket && this.$socket.connected) {
            // window.alert('Socket conectado')
            clearInterval(chequear)
            resolve(socket)
          } else if (++intentos >= maxRetries) {
            clearInterval(chequear)
            reject(new Error('Socket nunca apareció, como tus planes a largo plazo.'))
          }
        }, intervalo)
      })
    }
  },
  events: {
    updateBoards (classBoard) {
      this.classBoard = classBoard
    },
    inviteGame (data) {
      // window.alert('Invite: ' + JSON.stringify(data))
      if (data) {
        var invites = Store.get('invitesGame', [])
        this.invitesLength = invites.length
      }
    },
    confirmGame (data) {
      if (data) {
        var invites = Store.get('invitesGame', [])
        this.invitesLength = invites.length
      }
    },
    refreshInviteGame (data) {
      if (data) {
        var invites = Store.get('invitesGame', [])
        this.invitesLength = invites.length
      }
    },
    deleteInviteGame (data) {
      if (data) {
        var invites = Store.get('invitesGame', [])
        this.invitesLength = invites.length
      }
    },
    userLoguin (data) {
      this.esperarSocket(() => this.socket)
      .then((socket) => {
        if (this.$socket && this.$socket.connected) {
          this.userLoguinSocket()
        } else {
          window.swal('socket no conectado aún')
          this.userLoguinSocket()
        }
      })
    }
  },
  sockets: {
    event (data) {
      if (data.event === 'mensajegeneral') {
        // window.alert('mensaje: ' + JSON.stringify(data.data.men))
        if (data !== undefined && data.data !== undefined && data.data.men.send !== this.user.username) {
          this.toast(data.data.men.send + ': ' + data.data.men.body, 3000)
        }
      }
      this.$broadcast(data.event, data.data ? data.data : data)
      var invites = Store.get('invitesGame', [])
      // window.alert(JSON.stringify(data.data))
      this.invitesLength = invites.length
      if (data !== undefined && data.data !== undefined && data.data.recibe === this.user.username) {
        this.toast('Has recibio un reto, revisa los retos', 3000)
      }
    },
    disconnect (data) {
      // window.alert(JSON.stringify(data))
      if (this.user.role === 'Admin' || this.user.role === 'Teacher') {
        if (data.data !== undefined && data.data.name !== undefined) {
          this.loadOtherUser(data.data.name.username, function (someUser) {
            if (this.user.club === someUser.club) {
              // this.$broadcast(data.event, data.data ? data.data : data)
              if (this.lastSocketDisconnect !== data.data.name.username) {
                this.toast(data.data.name.username + ' se ha desconectado', 3000)
                // window.alert(data.data.name.username + ' se ha desconectado')
                this.lastSocketDisconnect = data.data.name.username
              }
            }
          }.bind(this))
        }
      }
    },
    connect (data) {
      this.testUser(function () {
        this.esperarSocket(() => this.socket)
        .then((socket) => {
          if (this.$socket && this.$socket.connected) {
            this.userLoguinSocket()
          } else {
            window.swal('socket no conectado aún')
            this.userLoguinSocket()
          }
        })
      }.bind(this))
      this.getLenguajeName()
      if (this.user) {
        this.loadClub(this.user.club)
      }
    }
  },
  created () {
  },
  ready () {
    clearInterval(this.intervalId)
    this.intervalId = setInterval(this.checkServerStatus, 40000)
    setInterval(() => {
      this.$socket.emit('heartbeat', 'Sigo vivo')
    }, 40000) // Cada 10 segundos
  },
  destroyed () {
    // window.alert('destoy')
    clearInterval(this.intervalId)
  },
  beforeDestroy () {
    // window.alert('destoy')
    clearInterval(this.intervalId)
  },
  components: {
    UserInvites
  },
  store
}
</script>

<style scoped>
#app {
  margin-top: 0px;
}
.dropdown-content
{
  min-width: fit-content; 
}
.dropdown-content li > a, .dropdown-content li > span
{
  color: white;
}
.dropdown-content
{
  background-color: #5c005c;
  top: auto !important;
}


.imagedropshadow {
    padding: 5px;
    border: solid 0px #EFEFEF;

    border: solid 0px #CCC;
    -moz-box-shadow: 1px 1px 5px #999;
    -webkit-box-shadow: 1px 1px 5px #999;
        box-shadow: 1px 1px 5px #999;
}

.frameVideoRight {
  padding: 5px;
    border: solid 0px #EFEFEF;
background: #5c005c;
    border: solid 0px #CCC;
    -moz-box-shadow: 1px 1px 5px #999;
    -webkit-box-shadow: 1px 1px 5px #999;
        box-shadow: 1px 1px 5px #999;
position: fixed;
right: 10px;
z-index: 200;
height:100%;
}
.nav-wrapper .right-nav {
  background: #5c005c;
}
.nav-wrapper .left-nav {
  background: #5c005c;
}


.md-sidenav .right-nav {
  background: initial !important;
}
.md-sidenav .left-nav {
  background: initial !important;
}



</style>



// WEBPACK FOOTER //
// App.vue?40636f08